<template>
    <footer class="flex-grow-0 bg-black flex-wrap pa-0 footer-has-image"
              :class="{'mobile': $vuetify.display.smAndDown}" name="app-footer">
        <v-container class="flex-1-1-100">
            <v-row justify="space-between" :class="{'pt-8': $vuetify.display.smAndDown}">
                <v-col v-for="(claim, c) in $page.props.footerClaims" :key="c" cols="12" md="3"
                       :class="{'pt-10 pb-10': $vuetify.display.mdAndUp, 'pt-3 pb-3': $vuetify.display.smAndDown}">
                    <v-row align="center" class="gc-3">
                        <v-col cols="auto" class="pr-0">
                            <client-only>
                            <v-icon
                                :icon="claim.icon"
                                :size="$vuetify.display.smAndDown ? 32 : 42"
                                color="orange"
                            ></v-icon>
                            </client-only>
                        </v-col>
                        <v-col class="pl-0" v-show="$vuetify.display.mdAndUp">
                            <p class="footer-level1-line font-weight-black text-claims">{{ claim.title }}</p>
                            <p class="footer-level1-line text-grey-lighten-1 text-claims">{{ claim.subtitle }}</p>
                        </v-col>
                        <v-col class="pl-0" v-show="$vuetify.display.smAndDown">
                            <span class="footer-level1-line font-weight-black mr-1">{{ claim.title }}</span>
                            <span class="footer-level1-line text-grey-lighten-1">{{ claim.subtitle }}</span>
                        </v-col>
                    </v-row>
                </v-col>

                <v-col cols="12" class="pt-0 pb-0" v-show="$vuetify.display.mdAndUp">
                    <v-divider></v-divider>
                </v-col>

                <v-col cols="12" class="pt-0 pb-0" v-show="$vuetify.display.smAndDown">
                    <v-expansion-panels variant="accordion" multiple class="pt-6">
                        <v-expansion-panel v-for="(item, i) in submenus" :key="i" class="c-expansion-panel">
                            <v-expansion-panel-title>
                                <div class="font-weight-black text-body-1">{{ item.title }}</div>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div v-for="(link, y) in item.children" :key="y" class="py-1">
                                    <a v-if="link.outside === 'Y'" :href="link.url" class="text-grey-lighten-1">{{ link.title }}</a>
                                    <Link v-else :href="link.url" class="text-grey-lighten-1">{{ link.title }}</Link>
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <template v-for="(item, i) in menu" :key="i">
                    <v-col
                        v-show="$vuetify.display.mdAndUp || item.type !== 'menu'"
                        cols="12" md="auto" class="footer-level2-col"
                        :class="{'pt-16 pb-16': $vuetify.display.mdAndUp, 'pt-6 pb-6': $vuetify.display.smAndDown}"
                    >
                        <div class="flc-title pb-10" v-show="$vuetify.display.mdAndUp">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="8" viewBox="0 0 24 8"
                                 fill="none">
                                <circle cx="20" cy="4" r="3.5" stroke="#6B6B6B"/>
                                <line x1="16" y1="4.5" x2="-4.37114e-08" y2="4.5" stroke="#6B6B6B"/>
                            </svg>
                            <div class="font-weight-black text-body-1">{{ item.title }}</div>
                        </div>
                        <div v-if="item.type !== 'menu'" v-show="$vuetify.display.smAndDown"
                             class="font-weight-black text-body-1"
                             :class="{'text-center':item.type === 'aboutbox'}">{{ item.title }}
                        </div>

                        <div v-if="item.type === 'menu'" v-show="$vuetify.display.mdAndUp" class="flc-menu">
                            <div v-for="(link, y) in item.children" :key="y">
                                <Link :href="link.url" class="text-grey-lighten-1 text-body-2">{{ link.title }}</Link>
                            </div>
                        </div>

                        <div v-if="item.type === 'aboutbox'">
                            <div :class="{'text-center pt-2': $vuetify.display.smAndDown}">
                                <span class="text-grey-lighten-1 text-body-2 mr-1">{{ item.address }}</span>
                                <Link :href="item.link_el.url" class="text-orange text-decoration-underline">
                                    {{ item.link_el.title }}
                                </Link>
                            </div>
                            <div class="flc-image mt-6">
                                <v-img
                                    width="300"
                                    aspect-ratio="16/9"
                                    cover
                                    class="rounded-lg mx-auto"
                                    src="../../../assets/images/footer/liberec-sklad.jpg"
                                ></v-img>
                                <svg :class="{'mobile': $vuetify.display.smAndDown}" xmlns="http://www.w3.org/2000/svg"
                                     width="92" height="69" viewBox="0 0 92 69" fill="none">
                                    <path
                                        d="M21.3193 16.1017H21.8782L35.0017 69H51.0208L73.2715 16.1017H73.915L67.4125 69H85.9378L92 0H61.9091L45.5005 43.3416H44.857L35.425 0H6.07915L0 69H18.5253L21.3363 16.1017H21.3193Z"
                                        fill="#EE8025"/>
                                </svg>
                            </div>
                        </div>

                        <div v-if="item.type === 'contact'" :class="{'pt-6':$vuetify.display.smAndDown}">
                            <div v-for="(contact, y) in item.children" :key="y">
                                <v-row v-if="contact.type === 'line'" align="center" class="gc-3"
                                       :class="{'mb-6': $vuetify.display.mdAndUp}">
                                    <v-col cols="auto" class="pr-0">
                                        <v-icon :icon="contact.icon" size="24" color="orange"></v-icon>
                                    </v-col>
                                    <v-col class="pl-0">
                                        <a :href="contact.url" class="font-weight-black text-h6 mb-n1" v-if="contact.main">
                                            {{ contact.main }}
                                        </a>
                                        <div class="text-body-2 text-grey-lighten-1 " v-if="contact.sub">
                                            {{ contact.sub }}
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row v-if="contact.type === 'social'"
                                       :class="{'mt-3': !$vuetify.display.mdAndUp, 'mt-6': $vuetify.display.smAndDown}"
                                       align="center">
                                    <v-col cols="auto">
                                        {{ contact.title }}
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col cols="auto" v-for="(social, s) in contact.socials" :key="s">
                                        <a :href="social.url" target="_blank" :aria-label="social.url">
                                            <v-icon :icon="social.icon" size="24" color="orange"></v-icon>
                                        </a>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>

                </template>
                <v-col cols="12" class="pt-0 pb-0" :class="{'pt-5 pb-6': $vuetify.display.smAndDown}">
                    <v-divider></v-divider>
                </v-col>
            </v-row>

            <v-row :class="{'gc-7': $vuetify.display.mdAndUp, 'gc-3': $vuetify.display.smAndDown}" justify="center"
                   align="center">
                <template v-for="(bottomItem, b) in footerBottom" :key="b">
                    <v-col v-if="bottomItem.type !== 'spacer'" cols="auto" class="pt-0 pb-0"
                           :class="{'mt-10 mb-10': $vuetify.display.mdAndUp, 'mt-0 mb-2 pl-0 pr-0': $vuetify.display.smAndDown}">
                        <div class="text-tiny-link text-grey-lighten-1"
                             v-if="bottomItem.type === 'static'"
                             v-show="$vuetify.display.mdAndUp"
                        >
                            {{ bottomItem.title }}
                        </div>
                        <Link
                            v-if="bottomItem.type === 'link'"
                            :class="{'text-tiny-link': $vuetify.display.mdAndUp, 'text-nano-link':$vuetify.display.smAndDown}"
                            class="text-grey-lighten-1 d-inline-block" :href="bottomItem.url"
                        >
                            {{ bottomItem.title }}
                        </Link>
                        <div :class="{'text-tiny-link': $vuetify.display.mdAndUp, 'text-nano-link':$vuetify.display.smAndDown}"
                             class="text-grey-lighten-1 cursor-pointer d-inline-block"
                             v-if="bottomItem.type === 'cookies'"
                             @click="showModalCookie">{{ bottomItem.title }}
                        </div>
                    </v-col>
                    <v-col
                        v-if="bottomItem.type === 'static'"
                        v-show="$vuetify.display.smAndDown" cols="12"
                        class="pt-0 pb-0 mt-0 mb-2 pl-0 pr-0"
                    >
                        <div class="text-tiny-link text-grey-lighten-1 text-center">{{ bottomItem.title }}</div>
                    </v-col>
                    <v-spacer v-if="bottomItem.type === 'spacer'" v-show="$vuetify.display.mdAndUp"></v-spacer>
                </template>
            </v-row>
        </v-container>
        <div id="footer-teleport" class="flex-1-1-100"></div>
    </footer>
</template>

<script setup>
import {Link, usePage} from "@inertiajs/vue3";
import {computed, inject, onMounted, ref} from "vue";
import {mdiFacebook, mdiInstagram} from "@mdi/js/mdi";
import {mdiEmailOutline, mdiPhoneOutline} from "@mdi/js";
import {trans} from "laravel-vue-i18n";
import ClientOnly from '../../components/ClientOnly.vue';

const route = inject('route');

const emit = defineEmits(['showModalCookie']);

const showModalCookie = () => emit('showModalCookie');

const footerBottom = computed(() => [
    {
        title: trans('app-footer.footer_company'),
        type: "static"
    },
    {
        type: "spacer"
    },
    ...Object.values(usePage().props.menu.bottomFooter)?.map(el => {
        return {
            url: el.url,
            title: el.title,
            type: el.type,
        }
    })
]);

const menu = computed(() => {
    const dynamicMenu = Object.values(usePage().props.menu.topFooter)?.sort((a,b) => a.sort - b.sort).map(gp => {
        return {
            title: gp.title,
            type: 'menu',
            children: gp.children?.sort((a,b) => a.sort - b.sort).map(child => {
                return {
                    title: child.title,
                    url: child.url,
                }
            })
        }
    });
    const menu = [
        {
            title: trans('app-footer.stock_title'),
            type: 'aboutbox',
            address: trans('app-footer.stock_address'),
            link_el: {
                title: trans('app-footer.stock_more_about_us'),
                url: route('aboutUs')
            },
            image: "../../../assets/images/footer/sklad.png"
        },
        {
            title: trans('app-footer.contact_title'),
            type: 'contact',
            children: [
                {
                    type: 'line',
                    icon: mdiPhoneOutline,
                    main: trans('app-footer.contact_phone'),
                    sub: trans('app-footer.contact_hours'),
                    url: "tel:"+trans('app-footer.contact_phone').replace(/ /g,'')
                },
                {
                    type: 'line',
                    icon: mdiEmailOutline,
                    main: trans('app-footer.contact_email'),
                    url: "mailto:"+trans('app-footer.contact_email')
                },
                {
                    type: 'social',
                    title: trans('app-footer.contact_social'),
                    socials: [
                        {
                            icon: mdiFacebook,
                            url: trans('app-footer.contact_facebook')
                        },
                        {
                            icon: mdiInstagram,
                            url: trans('app-footer.contact_instagram')
                        }
                    ]
                }
            ]
        }
    ];
    return [...dynamicMenu, ...menu];
});

const submenus = computed(() => menu.value.filter(item => item.type === 'menu'));

</script>
<style scoped lang="scss">
.footer-level1-line {
    line-height: 110%;
}

.flc-title {
    display: flex;
    align-items: center;
    gap: 12px;
    width: auto;
}

.flc-menu {
    display: flex;
    gap: 20px;
    flex-direction: column;
}

.cursor-pointer {
    cursor: pointer;
}

.flc-image {
    position: relative;

    svg {
        position: absolute;
        bottom: calc(-69px / 2);
        left: 24px;

        &.mobile {
            left: calc(50% - calc(92px / 2));
        }
    }
}

.footer-has-image {
    width: 100%;
    padding-bottom: calc(495px / 2) !important;
    background: linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 35.46%), url("../../../assets/images/footer/footer-foot.png"), lightgray 0px -94.164px / 100% 10% no-repeat;
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: contain;

    &.mobile {
        background: linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 35.46%), url("../../../assets/images/footer/footer-foot.png"), lightgray 50%;
        background-position: center bottom;
        background-repeat: no-repeat;

    }
}

.c-expansion-panel {
    border-radius: 0 !important;
    background-color: transparent;
    color: white;
    border-top: 1px solid #2B2B2B;

    &:last-child {
        border-bottom: 1px solid #2B2B2B;
    }

    .v-expansion-panel-title__overlay {
        opacity: 0;
    }
}
</style>
